<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش کلاس ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-select color="black" v-model="order" label="نوع ترتیب کلاس ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getOnlineClasses"></v-select>
          </v-col>
          <v-col cols="4">
            <v-select color="black" v-model="query.day" label="روز کلاس را انتخاب کنید" :items="[
                   {value:1, text:'شنبه'},
                   {value:2, text:'یکشنبه'},
                   {value:3, text:'دوشنبه'},
                   {value:4, text:'سه‌شنبه'},
                   {value:5, text:'چهارشنبه'},
                   {value:6, text:'پنجشنبه'},
                   {value:7, text:'جمعه'},
                   {value:'all', text:'تمام هفته'}
                    ]"
                      item-text="text" @change="getOnlineClasses"></v-select>
          </v-col>

          <v-col cols="4">
            <v-autocomplete color="black" v-model="query.school_id" label="آموزشگاه کلاس را انتخاب کنید"
                            :items="[{id: 'all', label: 'همه آموزشگاه ها'}, ...schools]"
                            item-value="id" item-text="label"
                            @change="getOnlineClasses"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left" v-if="userType !== 'instructor'">
            <v-btn style="letter-spacing: normal!important;" color="success" @click="getOnlineClasses('temporary')">
              کلاس های موقت
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/classes/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات کلاس ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/classes/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت کلاس جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="onlineClasses.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="6">مربی ها :
                      <div v-for="instructor in item.instructors" :key="instructor.id">
                        {{ instructor.name }}
                      </div>
                    </v-col>
                    <v-col v-if="item.students.length" cols="6">هنرجویان :
                      <div v-for="student in item.students" :key="student.id">
                        {{ student.name }}
                      </div>
                    </v-col>
                    <v-col v-else>هنرجویان :
                      هنوز هنرجویی در این کلاس وجود ندارد.
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success"
                            class="mx-1"
                            v-bind="attrs"
                            v-on="on" @click="$router.push('/classes/manage/students/'+item.id)">
                      mdi-account-multiple-outline
                    </v-icon>
                  </template>
                  <span class="tooltip-text">اطلاعات هنرجویان کلاس</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success"
                            class="mx-1"
                            v-bind="attrs"
                            v-on="on" @click="editUsersInClass(item)">
                      mdi-account-plus
                    </v-icon>
                  </template>
                  <span class="tooltip-text">ویرایش هنرجویان کلاس</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="success"
                            class="mx-1"
                            v-bind="attrs"
                            v-on="on" @click="$router.push('/classes/manage/index/'+item.id+'/all')">mdi-sitemap-outline
                    </v-icon>
                  </template>
                  <span class="tooltip-text">مدیریت هنرجویان کلاس</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="black"
                            class="mx-1"
                            v-bind="attrs"
                            v-on="on" @click="$router.push('/classes/sessions/index/'+item.id)">mdi-web
                    </v-icon>
                  </template>
                  <span class="tooltip-text">مدیریت جلسات آنلاین</span>
                </v-tooltip>
                <v-icon class="mx-1" color="purple" @click="$router.push('/classes/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.notification_count`]="{ item }">
                <v-badge v-if="item.notification_count" :content="item.notification_count" color="#1ab69d">
                  <v-icon>
                    mdi-bell
                  </v-icon>
                </v-badge>
              </template>
              <template
                  v-slot:[`item.cover`]="{ item }">
                <img :src="item.cover" height="150" width="150" :alt="item.title">
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="onlineClasses.current_page"
                :length="onlineClasses.last_page"
                circle
                @input="getOnlineClasses"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این کلاس اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>


    <v-dialog v-model="editUsersInClassDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-card-actions>
          <v-icon color="error" @click="editUsersInClassDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6">
            <v-autocomplete color="black" v-model="selectedStateId" :items="states"
                            label="استان مورد نظر را انتخاب کنید" item-value="id" item-text="label"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete color="black" v-model="selectedSchoolId" :items="schools"
                            label="آموزشگاه مورد نظر را انتخاب کنید" item-value="id" item-text="label"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-text-field label="برای جستجوی دقیق تر تایپ کنید..." color="black" v-model="needle"
                          hint="این قسمت در شماره همراه , نام و نام خانوادگی , ایمیل و شناسه جستجو خواهد شد."></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete label="هنرجویان" :items="students" multiple item-text="name" item-value="id"
                            color="black" v-model="onlineClass.students" deletable-chips chips>
            </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-btn color="primary" @click="getStudents()">
              جستجو
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn color="warning" @click="clearFields()">
              پاک کردن فیلد ها
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn color="success" @click="update()">
              ویرایش
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "OnlineClassIndex",
  data() {
    return {
      query: {
        day: 'all',
        school_id: 'all'
      },
      onlineClass: {
        title: null,
        school_id: null,
        course_id: null,
        day: null,
        hour: null,
        minute: null,
        capacity: null,
        start_date: null,
        pay_permission_date: null,
        cover: null,
        instructors: [],
        students: []
      },
      editUsersInClassDialog: false,
      selectedClassId: null,
      selectedStateId: null,
      selectedSchoolId: null,
      needle: null,
      userType: 'instructor',
      selectedEntityId: null,
      deleteDialog: false,
      expanded: [],
      singleExpand: false,
      loading: true,
      states: [],
      schools: [],
      students: [],
      orderItems: [
        {name: 'بر اساس روز', value: 'day'},
        {name: 'بر اساس زمان', value: 'hour'},
        {name: 'بر اساس آموزشگاه', value: 'school_id'},
        {name: 'بر اساس ظرفیت', value: 'capacity'},
        {name: 'بر اساس تاریخ شروع', value: 'start_date'},
        {name: 'بر اساس زمان ساخت', value: 'created_at'},
      ],
      order: 'created_at',
      onlineClasses: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '15%'},
        {text: 'نام مربی', value: 'instructor_name', align: 'center', width: '15%'},
        {text: 'نام آموزشگاه', value: 'school_name', align: 'center', width: '15%'},
        {text: 'تعداد هنرجو', value: 'students_count', align: 'center', width: '15%'},
        {text: 'روز', value: 'day_fa', align: 'center', width: '10%'},
        {text: 'ساعت', value: 'hour', align: 'center', width: '5%'},
        {text: 'دقیقه', value: 'minute', align: 'center', width: '3%'},
        {text: 'ظرفیت', value: 'capacity', align: 'center', width: '5%'},
        {text: 'رزرو شده', value: 'reserved', align: 'center', width: '5%'},
        {text: 'اعلان ها', value: 'notification_count', align: 'center', width: '5%'},
        {text: 'تاریخ شروع', value: 'start_date_fa', align: 'center', width: '3%'},
        {text: 'تاریخ اجازه پرداخت', value: 'pay_permission_date_fa', align: 'center', width: '10%'},
        {text: 'کاور', value: 'cover', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '10%'},
      ],
    }
  },
  mounted() {
    this.getSchools()
    this.getStates()
    this.userType = this.$cookies.get('userType')
    if (this.$cookies.get('userType') === 'instructor') this.$router.push('/classes/my/index')
    this.getOnlineClasses()
  },
  methods: {
    clearFields() {
      this.selectedSchoolId = null
      this.selectedStateId = null
      this.needle = null
    },
    getStudents() {
      let url = 'admin/student/index?per_page=1000'
      if (this.selectedSchoolId) {
        url = url + '&school_id=' + this.selectedSchoolId
      }
      if (this.selectedStateId) {
        url = url + '&state_id=' + this.selectedStateId
      }
      if (this.needle) {
        url = url + '&needle=' + this.needle
      }
      window.axios.get(url).then((res) => {
        this.students = res.data.data.data
      })
    },
    getSchools() {
      let url = '/school/admin-index'
      window.axios.get(url).then((res) => {
        this.schools = res.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getStates() {
      window.axios.get('system/state/index').then((res) => {
        this.states = res.data.data
      })
    },
    editUsersInClass(classInstance) {
      this.editUsersInClassDialog = true
      this.selectedClassId = classInstance.id
      this.getClass()
    },
    getClass() {
      this.onlineClass.students = []
      this.students = []
      window.axios.get('class/crud/get/' + this.selectedClassId).then((res) => {
        this.onlineClass = res.data.data
        this.onlineClass.start_date = res.data.data.start_date_fa
        this.onlineClass.pay_permission_date = res.data.data.pay_permission_date_fa
        if (this.onlineClass.instructors.length) {
          this.onlineClass.instructors.forEach((item, index) => {
            this.$set(this.onlineClass.instructors, index, item.id)
          })
        }
        if (this.onlineClass.students.length) {
          this.onlineClass.students.forEach((item, index) => {
            this.$set(this.students, index, item)
          })
          this.onlineClass.students.forEach((item, index) => {
            this.$set(this.onlineClass.students, index, item.id)
          })
        }
      })
    },

    update() {
      window.axios.post('class/crud/update/' + this.selectedClassId, this.onlineClass).then(() => {
        this.openSnackbar("کلاس مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },


    finalDestroy() {
      window.axios.delete('class/crud/delete/' + this.selectedEntityId).then(() => {
        this.getOnlineClasses()
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        } else {
          this.openSnackbar(err.message, '#F1416C')
        }
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    getOnlineClasses(query) {
      let url = '/class/crud/index?page=' + this.onlineClasses.current_page ?? 1
      url = url + '&order=' + this.order
      if (query) {
        if (query === 'temporary') {
          url = url + '&temporary=1'
        }
      }
      if (this.query.day) {
        url = url + "&day=" + this.query.day
      }
      if (this.query.school_id) {
        url = url + "&school_id=" + this.query.school_id
      }
      window.axios.get(url).then((res) => {
        this.onlineClasses = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
    ,
    destroy(onlineClassId) {
      this.selectedEntityId = onlineClassId
      this.deleteDialog = true
    }
  }
}
</script>

<style scoped>

</style>